export const experiences = [
  {
    role: "Web & App Developer",
    at: "Electric Vehicle Group, IIT Kharagpur",
    works:
      `Play a pivotal role in the front-end development of a web
application, utilizing React JS to create a seamless and userfriendly
interface.
Integrated multiple packages and APIs, including apex-charts
and Google Maps API, to enhance the application's
functionality and provide real-time data visualization.`,
  },
  {
    role: "Web Developer",
    at: "Entrepreneurship Cell, IIT Kharagpur",
    works:
      "Developed the website for Global Entrepreneurship Summit 2023, an initiative by E-Cell, IIT Kharagpur using DJANGO REST framework. Managed database of 3000+ participants for Entrepreneurship Cell, IIT Kharagpur that participated in GES 2023 using MySQL.",
  },
];